import { Observable } from 'rxjs';
import { NbMenuItem } from '@nebular/theme';
import { InjectionToken } from '@angular/core';

export interface SidebarNavigator {
  menu$: Observable<NbMenuItem[]>;
}

export const SIDEBAR_NAVIGATION = new InjectionToken<SidebarNavigator>(
  'vmspdf sidebar navigation',
);
